import React from "react";
import { Box, Button, useTheme } from "@material-ui/core";
import { CustomTheme } from "../../../../../../types/customTheme";

interface ActionButtonsProps {
  onCancel: () => void;
  onSave: () => void;
  isLoading: boolean;
  isEditDisabled: boolean
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  onCancel,
  onSave,
  isLoading,isEditDisabled
}) => {
  const theme: CustomTheme = useTheme()
  return (
    <Box display="flex" style={{ gap: "16px" }} mt={4}>
      <Button
        variant="outlined"
        onClick={onCancel}
        style={{
          flex: 1,
          height: "48px",
          borderRadius: "10px",
          border: "1px solid rgba(255,255,255,0.1)",
          textTransform: "none",
          fontWeight: "bold",
          backgroundColor: "rgba(255,255,255,0.02)",
        }}
      >
        Cancel
      </Button>
      <Button
        variant="contained"
        onClick={onSave}
        disabled={isLoading ||isEditDisabled}
        style={{
          flex: 4,
          height: "48px",
          borderRadius: "10px",
          backgroundColor: theme.palette.custom.blue.main,
          color: "white",
          textTransform: "none",
          fontWeight: "bold",
        }}
      >
        {isLoading ? "Saving..." : "Save Changes"}
      </Button>
    </Box>
  );
};

export default ActionButtons;